module.exports = __webpack_public_path__ + "media/Kinder.ad07e842.mp3";